var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"scroll-top-button",class:{ 'scroll-top-button--show': _vm.scrolled },attrs:{"type":"button"},on:{"click":_vm.scrollTop}},[_c('span',{staticClass:"fas fa-chevron-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }